export const movieCategories = [
  { slug: "dianying", name: "电影", icon: "ri-movie-line" },
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line" },
  { slug: "dongman", name: "动漫", icon: "ri-ghost-line" },
  { slug: "zongyi", name: "综艺", icon: "ri-live-line" },
];

export interface Movie {
  id: number;
  title: string;
  category: string;
  subCategory: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  genres: string[];
  duration: string;
  region: string;
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: "星际穿越",
    category: "dianying",
    subCategory: "科幻",
    year: 2024,
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20Interstellar%20space%20travel%20with%20astronaut%20floating%20near%20a%20massive%20black%20hole%20wormhole%20distant%20galaxy%20stars%20dramatic%20lighting%20deep%20space%20colors%20clean%20cinematic%20composition%20movie%20poster%20style%20professional%20design%20high%20quality&width=600&height=800&seq=movie-poster-01&orientation=portrait",
    description: "在不远的未来，地球面临着严重的环境危机。前NASA飞行员库珀被选中参加一项穿越虫洞的星际旅行任务，寻找人类的新家园。在浩瀚的宇宙中，时间变得相对，每一秒都可能意味着地球上数年的流逝。这部科幻巨制以惊人的视觉特效和深刻的情感内核，探讨了爱与时间、人类命运与宇宙奥秘之间的宏大主题。",
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    genres: ["科幻", "冒险", "剧情"],
    duration: "169分钟",
    region: "美国",
    updateDate: "2026-07-28",
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: "流浪地球3",
    category: "dianying",
    subCategory: "科幻",
    year: 2026,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20of%20Wandering%20Earth%20with%20massive%20planet%20engines%20pushing%20Earth%20through%20space%20futuristic%20technology%20dramatic%20cosmic%20background%20orange%20and%20deep%20blue%20tones%20epic%20cinematic%20poster%20style&width=600&height=800&seq=movie-poster-02&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了长达2500年的星际流浪之旅。第三部中，地球面临前所未有的宇宙灾难，人类团结一致，共同面对这场终极挑战。本片以宏大的叙事格局和震撼的视觉效果，展现了中国科幻电影的全新高度。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    genres: ["科幻", "冒险", "灾难"],
    duration: "178分钟",
    region: "中国大陆",
    updateDate: "2026-08-01",
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: "繁花",
    category: "dianshiju",
    subCategory: "都市",
    year: 2025,
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20poster%20set%20in%201990s%20Shanghai%20with%20elegant%20characters%20in%20vintage%20fashion%20neon%20lights%20cityscape%20nostalgic%20atmosphere%20warm%20golden%20tones%20sophisticated%20cinematic%20TV%20series%20poster%20design&width=600&height=800&seq=movie-poster-03&orientation=portrait",
    description: "九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧与勇气，在商海中沉浮，从一个小人物成长为商业大亨。这是一个关于时代、机遇与人生的传奇故事，也是一幅描绘改革开放大潮中上海市民生活的壮丽画卷。",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣"],
    genres: ["剧情", "都市", "商战"],
    duration: "30集",
    region: "中国大陆",
    updateDate: "2026-07-30",
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: "鬼灭之刃 无限城篇",
    category: "dongman",
    subCategory: "热血",
    year: 2026,
    rating: 9.5,
    image: "https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20of%20Demon%20Slayer%20with%20swordsman%20in%20traditional%20Japanese%20uniform%20holding%20katana%20dynamic%20action%20pose%20flame%20effects%20dark%20castle%20background%20dramatic%20lighting%20vibrant%20red%20and%20black%20colors%20cinematic%20anime%20poster&width=600&height=800&seq=movie-poster-04&orientation=portrait",
    description: "炭治郎一行人终于抵达了鬼舞辻无惨的据点——无限城。在这里，他们将面对史上最强大的敌人。柱与上弦之鬼之间的终极决战即将展开，无数生命将在这场战斗中消逝。本片以极致的动画制作水准和震撼的战斗场面，将鬼灭系列推向了新的巅峰。",
    director: "外崎春雄",
    actors: ["花江夏树", "鬼头明里", "下野纮"],
    genres: ["热血", "战斗", "奇幻"],
    duration: "120分钟",
    region: "日本",
    updateDate: "2026-08-02",
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: "喜剧之王2",
    category: "dianying",
    subCategory: "喜剧",
    year: 2026,
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20actor%20making%20exaggerated%20funny%20expression%20on%20a%20film%20set%20spotlight%20background%20warm%20vibrant%20colors%20playful%20cinematic%20atmosphere%20theatrical%20stage%20lighting%20movie%20poster%20style&width=600&height=800&seq=movie-poster-05&orientation=portrait",
    description: "一个普通的小镇青年怀揣着演员梦想来到大城市，在各种奇葩的剧组和龙套生活中摸爬滚打。他用执着和真诚打动了身边的人，最终在舞台上找到了属于自己的光芒。影片笑中带泪，致敬每一个怀揣梦想的普通人。",
    director: "周星驰",
    actors: ["王宝强", "沈腾", "马丽"],
    genres: ["喜剧", "励志", "剧情"],
    duration: "135分钟",
    region: "中国大陆",
    updateDate: "2026-07-25",
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: "三体：黑暗森林",
    category: "dianshiju",
    subCategory: "科幻",
    year: 2026,
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20series%20poster%20Three%20Body%20Problem%20with%20mysterious%20cosmic%20background%20three%20suns%20in%20sky%20futuristic%20laboratory%20equipment%20dark%20and%20moody%20atmosphere%20deep%20space%20tones%20intellectual%20thriller%20TV%20series%20poster%20design&width=600&height=800&seq=movie-poster-06&orientation=portrait",
    description: "面壁计划启动，四位面壁者被赋予了无上的权力来对抗三体文明的入侵。罗辑作为最不被看好的面壁者，却在无意中发现了宇宙社会学最黑暗的秘密——黑暗森林法则。本剧以缜密的科学逻辑和深刻的人文思考，打造了一部前所未有的国产科幻巨制。",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "王子文"],
    genres: ["科幻", "悬疑", "剧情"],
    duration: "40集",
    region: "中国大陆",
    updateDate: "2026-07-29",
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    title: "咒术回战 第二季",
    category: "dongman",
    subCategory: "战斗",
    year: 2025,
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Anime%20poster%20Jujutsu%20Kaisen%20with%20characters%20using%20supernatural%20cursed%20energy%20powers%20dynamic%20fighting%20poses%20dark%20urban%20Tokyo%20background%20vibrant%20blue%20and%20purple%20energy%20effects%20cinematic%20anime%20style%20high%20contrast&width=600&height=800&seq=movie-poster-07&orientation=portrait",
    description: "涩谷事变爆发，咒术界面临前所未有的危机。五条悟被封印，大量咒灵涌入涩谷。虎杖悠仁与伙伴们必须在这场地狱般的战斗中生存下来，同时寻找解救五条老师的方法。本季以紧凑的剧情节奏和精彩的战斗场面，成为年度最受瞩目的动漫作品。",
    director: "朴性厚",
    actors: ["榎木淳弥", "内田雄馬", "濑户麻沙美"],
    genres: ["战斗", "奇幻", "暗黑"],
    duration: "24集",
    region: "日本",
    updateDate: "2026-07-20",
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: "乘风破浪的姐姐5",
    category: "zongyi",
    subCategory: "竞演",
    year: 2026,
    rating: 8.2,
    image: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20confident%20female%20celebrities%20on%20glamorous%20stage%20spotlights%20shining%20elegant%20dresses%20sparkling%20stage%20effects%20golden%20and%20pink%20tones%20entertainment%20show%20poster%20vibrant%20atmosphere&width=600&height=800&seq=movie-poster-08&orientation=portrait",
    description: "三十位30+的姐姐再次集结，在这个舞台上重新出发。她们用汗水和实力证明，年龄从来不是限制，每个女性都能在自己的人生舞台上发光发热。本季融合了更多元的表演形式和更激烈的竞演规则，精彩程度全面升级。",
    director: "吴梦知",
    actors: ["宁静", "那英", "张雨绮", "王心凌"],
    genres: ["竞演", "音乐", "真人秀"],
    duration: "12期",
    region: "中国大陆",
    updateDate: "2026-08-01",
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: "蛟龙行动",
    category: "dianying",
    subCategory: "动作",
    year: 2026,
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20with%20naval%20special%20forces%20soldiers%20in%20tactical%20gear%20on%20a%20warship%20deck%20explosive%20action%20scene%20ocean%20background%20dramatic%20orange%20and%20teal%20color%20grading%20military%20cinematic%20poster%20style&width=600&height=800&seq=movie-poster-09&orientation=portrait",
    description: "中国海军蛟龙突击队接到一项绝密任务，前往某海域解救人质。在敌我力量悬殊的情况下，队员们凭借过硬的军事素质和团队协作，完成了一场惊心动魄的营救行动。影片以真实的军事行动为蓝本，展现了中国军人的铁血担当。",
    director: "林超贤",
    actors: ["黄景瑜", "张译", "杜江"],
    genres: ["动作", "军事", "战争"],
    duration: "142分钟",
    region: "中国大陆",
    updateDate: "2026-07-27",
    isHot: true,
    isNew: false,
  },
  {
    id: 10,
    title: "庆余年2",
    category: "dianshiju",
    subCategory: "古装",
    year: 2025,
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%20with%20handsome%20scholar%20in%20elegant%20traditional%20hanfu%20costume%20ancient%20Chinese%20palace%20background%20misty%20mountains%20ink%20wash%20painting%20style%20golden%20and%20crimson%20accents%20refined%20TV%20series%20poster&width=600&height=800&seq=movie-poster-10&orientation=portrait",
    description: "范闲从北齐归来后，在庆国朝堂上继续周旋于各方势力之间。他既要保护身边的人，又要揭开母亲叶轻眉死亡的真相。在这场权力的游戏中，每一步都如履薄冰。本季剧情更加扣人心弦，权谋与情感的交织令人欲罢不能。",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    genres: ["古装", "权谋", "爱情"],
    duration: "36集",
    region: "中国大陆",
    updateDate: "2026-07-22",
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: "蜘蛛侠：纵横宇宙2",
    category: "dongman",
    subCategory: "超级英雄",
    year: 2026,
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Animated%20Spider-Man%20movie%20poster%20with%20multiple%20spider-people%20from%20different%20dimensions%20dynamic%20comic%20book%20art%20style%20vibrant%20neon%20colors%20urban%20cityscape%20background%20graffiti%20elements%20modern%20animated%20film%20poster%20high%20energy&width=600&height=800&seq=movie-poster-11&orientation=portrait",
    description: "迈尔斯·莫拉莱斯穿越多元宇宙，遇见了来自不同维度的蜘蛛侠们。他们必须联手对抗一个威胁所有宇宙存亡的新敌人。每个蜘蛛侠都有自己的故事，而他们共同的使命是守护多元宇宙的和平。本片以革命性的动画风格，重新定义了超级英雄电影的可能性。",
    director: "乔伊姆·多斯·桑托斯",
    actors: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    genres: ["超级英雄", "动画", "冒险"],
    duration: "140分钟",
    region: "美国",
    updateDate: "2026-07-31",
    isHot: true,
    isNew: true,
  },
  {
    id: 12,
    title: "向往的生活8",
    category: "zongyi",
    subCategory: "生活",
    year: 2026,
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Chinese%20reality%20show%20poster%20with%20celebrities%20enjoying%20peaceful%20countryside%20life%20traditional%20Chinese%20courtyard%20house%20green%20fields%20warm%20sunset%20lighting%20cozy%20atmosphere%20natural%20and%20relaxing%20vibe%20variety%20show%20poster&width=600&height=800&seq=movie-poster-12&orientation=portrait",
    description: "新一季的蘑菇屋坐落在一片桃花源般的美景中。黄磊和何炅带着新老朋友们，在田间劳作、在厨房烹饪、在院子里谈天说地，用最简单的方式诠释最美好的生活。节目以温暖治愈的风格，成为无数观众的心灵栖息地。",
    director: "陈格洲",
    actors: ["黄磊", "何炅", "彭昱畅", "张子枫"],
    genres: ["生活", "美食", "真人秀"],
    duration: "14期",
    region: "中国大陆",
    updateDate: "2026-07-26",
    isHot: false,
    isNew: false,
  },
  {
    id: 13,
    title: "封神第二部",
    category: "dianying",
    subCategory: "奇幻",
    year: 2026,
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%20with%20ancient%20Chinese%20warriors%20in%20mythological%20armor%20riding%20mythical%20beasts%20dramatic%20battle%20scene%20thunder%20and%20lightning%20sky%20ancient%20Chinese%20architecture%20golden%20and%20crimson%20tones%20grand%20cinematic%20poster&width=600&height=800&seq=movie-poster-13&orientation=portrait",
    description: "姬发回到西岐后，召集天下英雄反抗殷寿的暴政。姜子牙携封神榜下山，一场决定天下归属的大战即将拉开帷幕。神仙妖魔各显神通，封神之战进入白热化阶段。本片以震撼的视觉特效和宏大的史诗叙事，呈现了中国神话的无穷魅力。",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    genres: ["奇幻", "古装", "战争"],
    duration: "156分钟",
    region: "中国大陆",
    updateDate: "2026-08-02",
    isHot: true,
    isNew: true,
  },
  {
    id: 14,
    title: "狂飙：暗流涌动",
    category: "dianshiju",
    subCategory: "悬疑",
    year: 2026,
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20series%20poster%20with%20detective%20in%20dark%20alley%20rainy%20night%20neon%20signs%20reflecting%20on%20wet%20street%20tense%20atmosphere%20film%20noir%20style%20mysterious%20shadows%20gritty%20urban%20setting%20TV%20series%20poster&width=600&height=800&seq=movie-poster-14&orientation=portrait",
    description: "扫黑除恶行动持续深入，新的犯罪势力在暗处蠢蠢欲动。安欣和他的团队面临更加复杂的案件，每一个线索背后都隐藏着更大的阴谋。正义与罪恶的对决再次升级。本剧以紧凑的叙事和出色的演技，延续了前作的高水准。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐"],
    genres: ["悬疑", "犯罪", "剧情"],
    duration: "39集",
    region: "中国大陆",
    updateDate: "2026-07-28",
    isHot: true,
    isNew: false,
  },
  {
    id: 15,
    title: "一人之下5",
    category: "dongman",
    subCategory: "奇幻",
    year: 2026,
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20martial%20arts%20fighters%20using%20supernatural%20qi%20energy%20powers%20modern%20urban%20and%20ancient%20temple%20fusion%20background%20dynamic%20action%20composition%20traditional%20Chinese%20ink%20brush%20effects%20vibrant%20red%20and%20black&width=600&height=800&seq=movie-poster-15&orientation=portrait",
    description: "张楚岚与宝儿姐继续追查甲申之乱的真相。新的异人势力浮出水面，三十六贼的秘密逐渐被揭开。在这场贯穿百年的阴谋中，每个人都扮演着不可或缺的角色。本季以浓厚的中国传统文化底蕴和精彩的打斗设计，展现了国漫的独特魅力。",
    director: "陈烨",
    actors: ["夏侯落枫", "小连杀", "图特哈蒙"],
    genres: ["奇幻", "战斗", "悬疑"],
    duration: "12集",
    region: "中国大陆",
    updateDate: "2026-07-25",
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    title: "奔跑吧兄弟12",
    category: "zongyi",
    subCategory: "户外",
    year: 2026,
    rating: 8.0,
    image: "https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%20with%20celebrity%20cast%20running%20and%20laughing%20in%20colorful%20sportswear%20bright%20sunny%20day%20scenic%20natural%20landscape%20energetic%20and%20fun%20atmosphere%20vibrant%20colorful%20design%20entertainment%20show%20poster&width=600&height=800&seq=movie-poster-16&orientation=portrait",
    description: "新一季跑男团再次出发，踏遍祖国大好河山。从冰天雪地的东北到阳光灿烂的海南，每一期都是全新的冒险。成员们用汗水和欢笑为观众带来最纯粹的快乐。节目以轻松愉快的氛围，成为全家老少都爱看的国民综艺。",
    director: "姚译添",
    actors: ["李晨", "郑恺", "沙溢", "白鹿"],
    genres: ["户外", "游戏", "真人秀"],
    duration: "12期",
    region: "中国大陆",
    updateDate: "2026-07-24",
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    title: "长安十二时辰2",
    category: "dianshiju",
    subCategory: "悬疑",
    year: 2026,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20series%20poster%20set%20in%20ancient%20Tang%20Dynasty%20Changan%20city%20with%20soldiers%20in%20traditional%20armor%20dramatic%20lighting%20city%20on%20fire%20mysterious%20atmosphere%20golden%20dusk%20sky%20epic%20scale%20cinematic%20TV%20series%20poster&width=600&height=800&seq=movie-poster-17&orientation=portrait",
    description: "天宝三年，一场蓄谋已久的阴谋再次笼罩长安城。张小敬再度临危受命，在十二个时辰内揭开层层迷雾，拯救这座千年古都于危难之中。本季延续了精良的制作水准和扣人心弦的叙事节奏，重现大唐盛世的繁华与危机。",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围"],
    genres: ["悬疑", "古装", "动作"],
    duration: "48集",
    region: "中国大陆",
    updateDate: "2026-08-01",
    isHot: true,
    isNew: true,
  },
  {
    id: 18,
    title: "铃芽之旅2",
    category: "dongman",
    subCategory: "日常",
    year: 2026,
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20with%20a%20young%20girl%20traveling%20through%20mystical%20landscapes%20doors%20floating%20in%20sky%20soft%20watercolor%20style%20cherry%20blossoms%20emotional%20atmosphere%20warm%20golden%20hour%20lighting%20cinematic%20anime%20composition%20dreamlike%20scenery&width=600&height=800&seq=movie-poster-18&orientation=portrait",
    description: "铃芽在关闭了各地的灾难之门后，开始了一段全新的旅程。这一次，她将探索那些被遗忘之地的秘密，遇见更多在灾难中幸存的人们，用温暖与勇气治愈每一个受伤的心灵。本片以唯美画风和真挚情感，延续了新海诚式的浪漫叙事。",
    director: "新海诚",
    actors: ["原菜乃华", "松村北斗", "深津绘里"],
    genres: ["奇幻", "冒险", "治愈"],
    duration: "122分钟",
    region: "日本",
    updateDate: "2026-07-30",
    isHot: false,
    isNew: true,
  },
  {
    id: 19,
    title: "八角笼中2",
    category: "dianying",
    subCategory: "动作",
    year: 2026,
    rating: 8.4,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sports%20drama%20movie%20poster%20with%20young%20boxers%20training%20in%20a%20rustic%20gym%20dusty%20training%20ring%20golden%20sunlight%20streaming%20through%20windows%20gritty%20realistic%20atmosphere%20determination%20in%20athletes%20eyes%20warm%20sepia%20tones%20inspirational%20cinema%20poster&width=600&height=800&seq=movie-poster-19&orientation=portrait",
    description: "向腾辉带领的格斗少年们在全国比赛中崭露头角后，面临着更大的挑战——国际赛事。这群从大山里走出来的孩子们，用拳拳到肉的拼搏精神，在世界的舞台上书写属于自己的传奇。影片真实而热血，展现了底层少年不屈的奋斗精神。",
    director: "王宝强",
    actors: ["王宝强", "陈永胜", "史彭元"],
    genres: ["动作", "励志", "剧情"],
    duration: "148分钟",
    region: "中国大陆",
    updateDate: "2026-07-29",
    isHot: false,
    isNew: true,
  },
  {
    id: 20,
    title: "大奉打更人",
    category: "dianshiju",
    subCategory: "古装",
    year: 2026,
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20martial%20arts%20series%20poster%20with%20officer%20in%20dark%20uniform%20holding%20magical%20sword%20ancient%20city%20at%20night%20mysterious%20fog%20supernatural%20elements%20traditional%20Chinese%20architecture%20dramatic%20moonlight%20epic%20TV%20series%20poster&width=600&height=800&seq=movie-poster-20&orientation=portrait",
    description: "许七安穿越到大奉王朝，成为了一名小小的打更人。在这个妖魔横行的世界，他凭借现代人的智慧和超凡的气运，一步步揭开王朝背后的惊天秘密。本剧融合了穿越、探案、修仙等多种元素，剧情跌宕起伏，令人拍案叫绝。",
    director: "邓科",
    actors: ["王鹤棣", "田曦薇", "刘奕君"],
    genres: ["古装", "奇幻", "探案"],
    duration: "40集",
    region: "中国大陆",
    updateDate: "2026-07-31",
    isHot: true,
    isNew: true,
  },
  {
    id: 21,
    title: "声生不息4",
    category: "zongyi",
    subCategory: "音乐",
    year: 2026,
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20variety%20show%20poster%20with%20singers%20on%20grand%20stage%20dramatic%20spotlight%20effects%20elegant%20stage%20design%20golden%20concert%20atmosphere%20musical%20notes%20floating%20in%20air%20professional%20entertainment%20show%20poster%20vibrant%20lighting&width=600&height=800&seq=movie-poster-21&orientation=portrait",
    description: "本季以'金曲盛典'为主题，邀请华语乐坛殿堂级歌手与新生代实力唱将同台竞技。跨越时代的经典金曲被全新演绎，在歌声中重温那些感动过无数人的旋律。节目以顶级的音乐制作水准，打造了一场华语音乐的视听盛宴。",
    director: "洪涛",
    actors: ["周杰伦", "林俊杰", "邓紫棋", "毛不易"],
    genres: ["音乐", "竞演", "真人秀"],
    duration: "12期",
    region: "中国大陆",
    updateDate: "2026-07-28",
    isHot: false,
    isNew: false,
  },
  {
    id: 22,
    title: "阿凡达3：火与灰",
    category: "dianying",
    subCategory: "科幻",
    year: 2026,
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20of%20Avatar%20with%20blue%20Navi%20warriors%20riding%20flying%20creatures%20on%20alien%20planet%20volcanic%20eruption%20background%20bioluminescent%20forest%20dramatic%20fire%20and%20ice%20contrast%20cinematic%20IMAX%20quality%20grand%20scale%20fantasy%20adventure%20poster&width=600&height=800&seq=movie-poster-22&orientation=portrait",
    description: "杰克·萨利和奈蒂莉在潘多拉星球上遇到了全新的纳威部落——火焰族。这个生活在火山区域的部落拥有完全不同的文化和生存方式。当人类殖民者的威胁再次逼近时，所有纳威部落必须团结一致，共同保卫他们的家园。",
    director: "詹姆斯·卡梅隆",
    actors: ["萨姆·沃辛顿", "佐伊·索尔达娜", "西格妮·韦弗"],
    genres: ["科幻", "冒险", "奇幻"],
    duration: "192分钟",
    region: "美国",
    updateDate: "2026-08-02",
    isHot: true,
    isNew: true,
  },
  {
    id: 23,
    title: "王牌对王牌9",
    category: "zongyi",
    subCategory: "游戏",
    year: 2026,
    rating: 8.1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20game%20variety%20show%20poster%20with%20celebrities%20laughing%20and%20playing%20games%20on%20colorful%20stage%20set%20confetti%20celebration%20atmosphere%20bright%20vibrant%20colors%20energetic%20entertainment%20show%20design%20fun%20party%20vibe&width=600&height=800&seq=movie-poster-23&orientation=portrait",
    description: "王牌家族再度集结，沈腾、贾玲带领新老成员们展开更加爆笑的游戏对决。经典IP剧组重聚、爆笑游戏挑战、感人故事分享，每一期都充满惊喜与欢乐。节目以幽默轻松的风格，成为周末合家欢的最佳选择。",
    director: "吴彤",
    actors: ["沈腾", "贾玲", "华晨宇", "关晓彤"],
    genres: ["游戏", "喜剧", "真人秀"],
    duration: "12期",
    region: "中国大陆",
    updateDate: "2026-07-27",
    isHot: false,
    isNew: false,
  },
  {
    id: 24,
    title: "深海2",
    category: "dongman",
    subCategory: "日常",
    year: 2026,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20underwater%20fantasy%20world%20colorful%20coral%20reefs%20glowing%20jellyfish%20a%20young%20girl%20swimming%20in%20magical%20deep%20ocean%20vibrant%20neon%20colors%20dreamlike%20atmosphere%20artistic%20ink%20wash%20blend%20cinematic%20quality%20animation%20poster&width=600&height=800&seq=movie-poster-24&orientation=portrait",
    description: "参宿从深海大饭店的奇幻冒险中归来后，发现自己拥有了进入他人梦境的能力。这一次，她将帮助更多被困在内心世界的人们走出阴霾。影片以惊艳的水墨粒子动画和深刻的情感表达，被誉为中国动画电影的又一里程碑之作。",
    director: "田晓鹏",
    actors: ["苏鑫", "王亭文", "滕奎兴"],
    genres: ["奇幻", "治愈", "冒险"],
    duration: "125分钟",
    region: "中国大陆",
    updateDate: "2026-08-02",
    isHot: false,
    isNew: true,
  },
];

export const categoryNames: Record<string, string> = {
  dianying: "电影",
  dianshiju: "电视剧",
  dongman: "动漫",
  zongyi: "综艺",
};

export const getMoviesByCategory = (category: string): Movie[] => {
  return movies.filter((m) => m.category === category);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getHotMovies = (limit = 8): Movie[] => {
  return movies.filter((m) => m.isHot).slice(0, limit);
};

export const getNewMovies = (limit = 8): Movie[] => {
  return movies.filter((m) => m.isNew).slice(0, limit);
};

export const getRelatedMovies = (movie: Movie, limit = 6): Movie[] => {
  return movies
    .filter((m) => m.id !== movie.id && (m.category === movie.category || m.genres.some((g) => movie.genres.includes(g))))
    .slice(0, limit);
};

export const heroMovies = movies.filter((m) => m.isHot).slice(0, 4);